export default __webpack_public_path__ + "static/ceslogo-64205e5bcadcb7e1dd7ceb6490835bfb.jpg";